export const TRANSLATIONS_ADD = "TRANSLATIONS_ADD"
export const TRANSLATIONS_EDIT = "TRANSLATIONS_EDIT"
export const TRANSLATIONS_REMOVE = "TRANSLATIONS_REMOVE"
export const TRANSLATIONS_SET = "TRANSLATIONS_SET"
export const TRANSLATIONS_STATUS = "TRANSLATIONS_STATUS"
